import { ApolloLink } from '@apollo/client';

/**
 * Apollo link that triggers background token refresh on each request.
 * Does not block the request - refresh happens asynchronously.
 */
const tokenRefreshLink = ({ refreshTokenAsync }) =>
  new ApolloLink((operation, forward) => {
    // Trigger background token refresh without blocking
    if (refreshTokenAsync) {
      refreshTokenAsync();
    }

    // Pass the operation to the next link
    return forward(operation);
  });

export default tokenRefreshLink;
